import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@stacklet/ui";

interface Props {
  isOpen: boolean;
  isPending: boolean;
  isEditMode: boolean;
  issueCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export function HighIssueCountConfirmationDialog({
  isOpen,
  isPending,
  isEditMode,
  issueCount,
  onCancel,
  onConfirm,
}: Props) {
  const confirmText = isEditMode ? "Yes, update rule" : "Yes, create rule";
  const pendingText = isEditMode ? "Updating..." : "Creating...";

  return (
    <Dialog
      isOpen={isOpen}
      onOpenChange={(open) => !open && onCancel()}
      size="md"
    >
      <DialogHeader>Confirm high issue volume</DialogHeader>
      <DialogContent>
        This rule is expected to generate {issueCount} issues. Are you sure you
        want to continue?
      </DialogContent>
      <DialogFooter>
        <Button
          className="border-transparent"
          isDisabled={isPending}
          onPress={onCancel}
          variant="tertiary"
        >
          Cancel
        </Button>
        <Button
          isDisabled={isPending}
          isPending={isPending}
          onPress={onConfirm}
          pendingText={pendingText}
        >
          {confirmText}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
